import { NSARouterMakerProps, NSAHomePage } from 'namirasoft-account-react';
import { NotificationSenderLayout } from '../NotificationSenderLayout';

interface IHomePageIProps extends NSARouterMakerProps { }

function HomePage(props: IHomePageIProps)
{
	return (
		<>
			<NotificationSenderLayout
				{...props}
			>
				<NSAHomePage
					{...props}
				/>
			</NotificationSenderLayout>
		</>
	);
}

export default HomePage;